'use client';

import { c as _c } from "react/compiler-runtime";
import type { OnrampClient } from '@morfi/onramp-sdk';
import { useFundingAuthentication, type useFundingNavigation } from '@morfi/onramp-sdk/react';
import { useRef } from 'react';
export function useFundingEntryAuthentication(client, navigation) {
  const $ = _c(4);
  const explicitLogin = useRef(false);
  let t0;
  if ($[0] !== navigation) {
    t0 = () => {
      navigation.transition(!explicitLogin.current && navigation.getSnapshot().checkout === "profile" ? "profile_requested" : "session_refreshed");
    };
    $[0] = navigation;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const authentication = useFundingAuthentication(client, t0);
  let t1;
  if ($[2] !== authentication) {
    t1 = {
      ...authentication,
      async authenticate(email) {
        if (authentication.busy || explicitLogin.current) {
          return;
        }
        explicitLogin.current = true;
        await authentication.authenticate(email).finally(() => {
          explicitLogin.current = false;
        });
      }
    };
    $[2] = authentication;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}